module.exports = false;



//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 2